module.exports = __webpack_public_path__ + "static/img/bg-es.ddc8297d.png";